import { useQuery } from '@apollo/client';

import GetCoursesByIdsQuery from 'bundles/course-v2/queries/GetCoursesByIdsQuery.graphql';
import type {
  GetCoursesByIdsQuery as GetCoursesByIdsQueryType,
  GetCoursesByIdsQueryVariables,
} from 'bundles/course-v2/queries/__generated__/GetCoursesByIdsQuery';

export type CourseData = NonNullable<GetCoursesByIdsQueryType['Course']>['queryByIds'][number];

type CoursesByIdsResult = {
  courseData: CourseData[] | undefined;
  loading: boolean;
  error: Error | undefined;
};

/**
 * Fetches multiple courses by their IDs
 * @param ids Array of course IDs
 * @returns Course data array, loading state, and error
 */
const useCoursesByIds = (ids: string[]): CoursesByIdsResult => {
  const { data, loading, error } = useQuery<GetCoursesByIdsQueryType, GetCoursesByIdsQueryVariables>(
    GetCoursesByIdsQuery,
    {
      variables: {
        ids,
      },
      context: { clientName: 'gatewayGql' },
      skip: !ids || ids.length === 0,
    }
  );

  const courseData = data?.Course?.queryByIds;

  return {
    courseData: courseData || undefined,
    loading,
    error,
  };
};

export default useCoursesByIds;
